export const tabs = () => {
  const tabs = document.querySelectorAll("[data-tabs]");

  const changeTab = (item, headerItems) => {
    const tabName = item.parentNode.getAttribute("data-tabs-name");
    let currentItem = item;
    headerItems.forEach((element) => {
      element.classList.remove("isActive");
    });
    currentItem.classList.add("isActive");
    let dataItem = currentItem.getAttribute("data-tabs-header-item");

    const currentContents = document.querySelectorAll(
      `[data-tabs-name="${tabName}"] .tabs-content__item`
    );
    const currentImages = document.querySelectorAll(
      `[data-tabs-name="${tabName}"] .tabs-image`
    );
    currentContents.forEach((content) => {
      content.classList.remove("isActive");
      if (content.getAttribute("data-tabs-content-item") === dataItem) {
        content.classList.add("isActive");
      }
    });
    currentImages.forEach((content) => {
      content.classList.remove("isActive");
      if (content.getAttribute("data-tabs-image-item") === dataItem) {
        content.classList.add("isActive");
      }
    });
  };

  tabs.forEach((element) => {
    const tabsItems = element.querySelectorAll(".tabs-header__item");

    tabsItems.forEach((item) => {
      item.addEventListener("click", () => changeTab(item, tabsItems));
    });

    if (tabsItems.length > 0) changeTab(tabsItems[0], tabsItems);

    const prevBtn = element.querySelector(".tabs-header__arrow--prev");
    const nextBtn = element.querySelector(".tabs-header__arrow--next");

    const goToOffset = (offset) => {
      const currentIndex = Array.from(tabsItems).findIndex((item) =>
        item.classList.contains("isActive")
      );
      const nextIndex =
        (currentIndex + offset + tabsItems.length) % tabsItems.length;
      changeTab(tabsItems[nextIndex], tabsItems);
    };

    if (prevBtn) {
      prevBtn.addEventListener("click", () => goToOffset(-1));
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => goToOffset(1));
    }

    const contentWrapper = element.querySelector(".tabs-content-wrapper");
    if (contentWrapper && tabsItems.length > 1) {
      const swipeMQ = window.matchMedia("(max-width: 991px)");
      const swipeThreshold = 50;
      const swipeRestraint = 75;
      let touchStartX = 0;
      let touchStartY = 0;

      contentWrapper.addEventListener(
        "touchstart",
        (event) => {
          if (!swipeMQ.matches) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      contentWrapper.addEventListener(
        "touchend",
        (event) => {
          if (!swipeMQ.matches) return;
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          const deltaY = event.changedTouches[0].clientY - touchStartY;

          if (
            Math.abs(deltaX) >= swipeThreshold &&
            Math.abs(deltaY) <= swipeRestraint
          ) {
            goToOffset(deltaX < 0 ? 1 : -1);
          }
        },
        { passive: true }
      );
    }
  });
};
